import { useTranslation } from '@fluxora/i18n';
import { Badge } from '@fluxora/ui';

import type { DeepLinkSource } from '../schemas/shop.schema';
import { sourceLabelKey } from '../services/deep-link.service';

/**
 * AC1 — the "via Power to Choose" attribution shown on a deep-link landing. Pure
 * attribution/UX; the source is never trusted for anything security-sensitive.
 */
export interface SourceBadgeProps {
  readonly source: DeepLinkSource;
}

export function SourceBadge({ source }: SourceBadgeProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <Badge variant="primary" data-testid="source-badge">
      {t('shop.deepLink.badge', { source: t(sourceLabelKey(source)) })}
    </Badge>
  );
}
